<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			body: ISbStoryData[];
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div
	use:editable={content}
	class="hero-bg-light min-h-svh transition-transform lg:mt-5 xl:flex"
	style="transform: translate3d(0, var(--header-height), 0); padding-bottom: var(--header-height);"
	id="hero"
	itemscope
	itemtype="http://schema.org/Product"
>
	{#each content.body || [] as block}
		<Blok content={block} />
	{/each}
</div>
